import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import dayjs, { Dayjs } from 'dayjs';
import {
  DateRange,
  PickersShortcutsItem,
  SingleInputDateRangeField,
} from '@mui/x-date-pickers-pro';
import Box from '@mui/material/Box';

export function DateFilter(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const minDate = dayjs().subtract(180, 'day');

  const handleFilterChange = (newValue: DateRange<dayjs.Dayjs>) => {
    applyValue({ ...item, value: newValue });
  };

  const shortcutsItems: PickersShortcutsItem<DateRange<Dayjs>>[] = [
    {
      label: 'Last Week',
      getValue: () => {
        const today = dayjs();
        const prevWeek = today.subtract(7, 'day');
        return [prevWeek.startOf('week'), prevWeek.endOf('week')];
      },
    },
    {
      label: 'Last 7 Days',
      getValue: () => {
        const today = dayjs();
        return [today.subtract(7, 'day'), today];
      },
    },
    {
      label: 'Last Month',
      getValue: () => {
        const today = dayjs();
        const prevMonth = today.subtract(1, 'month');
        return [prevMonth.startOf('month'), prevMonth.endOf('month')];
      },
    },
    { label: 'Clear', getValue: () => [null, null] },
  ];

  return (
    <Box
      sx={{
        width: 300,
        position: 'relative',
        top: -19.5,
      }}
    >
      <DateRangePicker
        sx={{ width: 300 }}
        label={'Date Range'}
        value={item.value || [null, null]}
        calendars={2}
        onChange={handleFilterChange}
        disableFuture
        minDate={minDate}
        slotProps={{
          textField: {
            variant: 'standard',
          },
          shortcuts: {
            items: shortcutsItems,
          },
          actionBar: { actions: [] },
        }}
        slots={{ field: SingleInputDateRangeField }}
      />
    </Box>
  );
}
